import React from 'react';

import { Container } from './styles';

const ConfigPage: React.FC = () => <Container>Config</Container>;

export default ConfigPage;
